module.exports = __webpack_public_path__ + "europa-100_portrait_window.jpg?bcd080856679bf19073b6507fa953438";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-100_portrait_window.jpg
// module id = 272
// module chunks = 0